import { FC, HTMLAttributes } from 'react';

type ConnectDiscordProps = HTMLAttributes<SVGElement> & {
  size?: number;
  shouldBlend?: boolean;
};

const ConnectDiscord: FC<ConnectDiscordProps> = ({
  size = 40,
  shouldBlend = false,
  ...props
}) => {
  if (shouldBlend)
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g filter="url(#filter0_d_641_12438)">
          <rect
            x="5.38867"
            y="4.00977"
            width="30"
            height="30"
            rx="5.47911"
            fill="#EBEFFF"
          />
          <rect
            x="5.84526"
            y="4.46636"
            width="29.0868"
            height="29.0868"
            rx="5.02252"
            stroke="#4147D5"
            stopOpacity="0.5"
            strokeWidth="0.913185"
          />
          <g clipPath="url(#clip0_641_12438)">
            <path
              d="M11.773 23.0832C11.773 19.6131 13.0124 15.0276 14.2517 13.1686C14.2517 13.1686 15.491 12.5489 20.4483 12.5489C25.4056 12.5489 26.645 13.1686 26.645 13.1686C27.8843 15.0276 29.1236 19.6131 29.1236 23.0832C28.7106 23.7029 27.2646 25.0661 24.786 25.5619L22.6059 22.8367C21.9589 22.9888 21.2225 23.0832 20.4483 23.0832C19.6742 23.0832 18.9378 22.9888 18.2908 22.8367L16.1107 25.5619C13.632 25.0661 12.1861 23.7029 11.773 23.0832Z"
              fill="#4147D5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.7953 13.8483C14.2924 14.6983 13.7615 16.0964 13.3437 17.7258C12.916 19.394 12.6279 21.2217 12.5976 22.8095C13.0154 23.2964 14.0718 24.1909 15.7918 24.6448L17.649 22.3233C17.8471 22.0757 18.1701 21.9641 18.4788 22.0367C19.0662 22.1747 19.7395 22.2613 20.4483 22.2613C21.1572 22.2613 21.8305 22.1747 22.4179 22.0367C22.7266 21.9641 23.0495 22.0757 23.2476 22.3233L25.1048 24.6448C26.8249 24.1908 27.8813 23.2964 28.299 22.8095C28.2688 21.2217 27.9806 19.394 27.5529 17.7258C27.1351 16.0964 26.6043 14.6983 26.1014 13.8483C25.9407 13.8019 25.6745 13.7368 25.2705 13.6694C24.397 13.5239 22.8949 13.3708 20.4483 13.3708C18.0017 13.3708 16.4996 13.5239 15.6261 13.6694C15.2222 13.7368 14.956 13.8019 14.7953 13.8483ZM26.645 13.1686L27.0125 12.4335C27.1404 12.4974 27.2495 12.5937 27.3288 12.7127C28.0252 13.7573 28.6725 15.4744 29.1451 17.3176C29.6221 19.1778 29.9454 21.2621 29.9454 23.0832C29.9454 23.2454 29.8974 23.404 29.8075 23.539C29.2711 24.3439 27.6351 25.8302 24.9472 26.3678C24.6459 26.4281 24.3361 26.3153 24.1442 26.0753L22.2786 23.7432C21.7076 23.8454 21.0896 23.9051 20.4483 23.9051C19.807 23.9051 19.1891 23.8454 18.6181 23.7432L16.7525 26.0753C16.5605 26.3153 16.2508 26.4281 15.9495 26.3678C13.2615 25.8302 11.6257 24.3439 11.0892 23.5391C10.9992 23.4041 10.9512 23.2454 10.9512 23.0832C10.9512 21.2621 11.2745 19.1778 11.7515 17.3176C12.2241 15.4744 12.8715 13.7573 13.5679 12.7127C13.6472 12.5937 13.7562 12.4974 13.8842 12.4335L14.2517 13.1686C13.8842 12.4335 13.8847 12.4332 13.8853 12.4329L13.8865 12.4323L13.889 12.4311L13.8942 12.4285L13.906 12.4229C13.9145 12.4189 13.9241 12.4145 13.9351 12.4097C13.957 12.4 13.984 12.3887 14.0168 12.376C14.0822 12.3505 14.1706 12.3193 14.2866 12.2845C14.5183 12.215 14.8625 12.1303 15.3559 12.0481C16.3414 11.8838 17.9376 11.7271 20.4483 11.7271C22.959 11.7271 24.5552 11.8838 25.5407 12.0481C26.0342 12.1303 26.3783 12.215 26.61 12.2845C26.726 12.3193 26.8145 12.3505 26.8799 12.376C26.9126 12.3887 26.9397 12.4 26.9616 12.4097C26.9725 12.4145 26.9822 12.4189 26.9907 12.4229L27.0025 12.4285L27.0077 12.4311L27.0102 12.4323L27.0113 12.4329C27.0119 12.4332 27.0125 12.4335 26.645 13.1686Z"
              fill="#4147D5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.5297 21.2627C15.8506 20.9417 16.371 20.9417 16.692 21.2627C16.9085 21.4793 17.5221 21.8118 18.4789 22.0366C19.0663 22.1746 19.7396 22.2613 20.4484 22.2613C21.1573 22.2613 21.8306 22.1746 22.418 22.0366C23.3748 21.8118 23.9884 21.4793 24.2049 21.2627C24.5259 20.9417 25.0463 20.9417 25.3672 21.2627C25.6882 21.5836 25.6882 22.104 25.3673 22.425C24.8284 22.9639 23.8575 23.3869 22.794 23.6368C22.0874 23.8028 21.288 23.905 20.4484 23.905C19.6089 23.905 18.8095 23.8028 18.1029 23.6368C17.0394 23.3869 16.0685 22.9639 15.5296 22.425C15.2087 22.104 15.2087 21.5836 15.5297 21.2627Z"
              fill="#EBEFFF"
            />
            <path
              d="M15.6541 17.9923C15.6541 18.3556 15.7984 18.704 16.0553 18.9609C16.3121 19.2178 16.6605 19.3621 17.0238 19.3621C17.3871 19.3621 17.7355 19.2178 17.9924 18.9609C18.2493 18.704 18.3936 18.3556 18.3936 17.9923C18.3936 17.629 18.2493 17.2806 17.9924 17.0238C17.7355 16.7669 17.3871 16.6226 17.0238 16.6226C16.6605 16.6226 16.3121 16.7669 16.0553 17.0238C15.7984 17.2806 15.6541 17.629 15.6541 17.9923Z"
              fill="white"
            />
            <path
              d="M22.5029 17.9923C22.5029 18.3556 22.6472 18.704 22.9041 18.9609C23.161 19.2178 23.5094 19.3621 23.8727 19.3621C24.236 19.3621 24.5844 19.2178 24.8413 18.9609C25.0982 18.704 25.2425 18.3556 25.2425 17.9923C25.2425 17.629 25.0982 17.2806 24.8413 17.0238C24.5844 16.7669 24.236 16.6226 23.8727 16.6226C23.5094 16.6226 23.161 16.7669 22.9041 17.0238C22.6472 17.2806 22.5029 17.629 22.5029 17.9923Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_641_12438"
            x="0.822745"
            y="0.357024"
            width="39.1319"
            height="39.1319"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.913185" />
            <feGaussianBlur stdDeviation="2.28296" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.87451 0 0 0 0 0.898039 0 0 0 0 0.976471 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_641_12438"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_641_12438"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_641_12438">
            <rect
              width="20.0901"
              height="20.0901"
              fill="white"
              transform="translate(10.3436 8.96436)"
            />
          </clipPath>
        </defs>
      </svg>
    );

  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.4375"
        y="0.458008"
        width="24"
        height="24"
        rx="6"
        fill="#EBEFFF"
      />
      <rect
        x="0.9375"
        y="0.958008"
        width="23"
        height="23"
        rx="5.5"
        stroke="#4147D5"
        stopOpacity="0.5"
      />
      <path
        d="M4.88797 16.0267C4.88797 12.9867 5.97369 8.96956 7.05941 7.34098C7.05941 7.34098 8.14513 6.79812 12.488 6.79812C16.8308 6.79812 17.9166 7.34098 17.9166 7.34098C19.0023 8.96956 20.088 12.9867 20.088 16.0267C19.7262 16.5696 18.4594 17.7639 16.288 18.1982L14.3781 15.8108C13.8113 15.944 13.1662 16.0267 12.488 16.0267C11.8098 16.0267 11.1647 15.944 10.5979 15.8108L8.68798 18.1982C6.51655 17.7639 5.24987 16.5696 4.88797 16.0267Z"
        fill="#4147D5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53563 7.93643C7.09502 8.6811 6.63001 9.90592 6.26398 11.3334C5.88927 12.7948 5.63683 14.396 5.61029 15.787C5.97635 16.2135 6.9018 16.9971 8.40865 17.3948L10.0357 15.361C10.2092 15.1441 10.4921 15.0463 10.7626 15.1099C11.2772 15.2308 11.867 15.3067 12.488 15.3067C13.109 15.3067 13.6988 15.2308 14.2134 15.1099C14.4839 15.0463 14.7668 15.1441 14.9403 15.361L16.5673 17.3948C18.0742 16.9971 18.9997 16.2135 19.3657 15.787C19.3391 14.396 19.0867 12.7948 18.712 11.3334C18.346 9.90591 17.881 8.68109 17.4404 7.93644C17.2996 7.89583 17.0664 7.83873 16.7125 7.77975C15.9473 7.65222 14.6313 7.51812 12.488 7.51812C10.3446 7.51812 9.02869 7.65222 8.26349 7.77975C7.90963 7.83873 7.67642 7.89583 7.53563 7.93643ZM17.9166 7.34098L18.2386 6.69698C18.3506 6.75302 18.4461 6.83733 18.5157 6.94158C19.1258 7.85672 19.6929 9.36098 20.1069 10.9757C20.5247 12.6054 20.808 14.4313 20.808 16.0267C20.808 16.1688 20.7659 16.3077 20.6871 16.426C20.2172 17.1312 18.784 18.4332 16.4292 18.9042C16.1653 18.957 15.8939 18.8582 15.7258 18.648L14.0914 16.6049C13.5911 16.6945 13.0498 16.7467 12.488 16.7467C11.9262 16.7467 11.3849 16.6945 10.8846 16.6049L9.25021 18.648C9.08206 18.8582 8.81071 18.957 8.54676 18.9042C6.19194 18.4332 4.75886 17.1311 4.28887 16.4261C4.21004 16.3078 4.16797 16.1689 4.16797 16.0267C4.16797 14.4313 4.45125 12.6054 4.86911 10.9757C5.28315 9.36097 5.85025 7.85672 6.46033 6.94159C6.52984 6.83734 6.62535 6.75302 6.73742 6.69699L7.05941 7.34098C6.73742 6.69699 6.73793 6.69674 6.73844 6.69648L6.73948 6.69596L6.74163 6.6949L6.74622 6.69266L6.75656 6.68773C6.76398 6.68424 6.77245 6.68037 6.78205 6.67614C6.80123 6.66768 6.82491 6.65776 6.85359 6.64661C6.91089 6.62432 6.98839 6.59701 7.09002 6.56652C7.29299 6.50563 7.59446 6.4314 8.02676 6.35935C8.89015 6.21545 10.2885 6.07812 12.488 6.07812C14.6875 6.07812 16.0858 6.21545 16.9492 6.35935C17.3815 6.4314 17.683 6.50563 17.886 6.56652C17.9876 6.59701 18.0651 6.62432 18.1224 6.64661C18.1511 6.65776 18.1748 6.66767 18.1939 6.67614C18.2035 6.68037 18.212 6.68424 18.2194 6.68772L18.2298 6.69265L18.2344 6.69489L18.2365 6.69596L18.2375 6.69648C18.2381 6.69673 18.2386 6.69698 17.9166 7.34098Z"
        fill="#4147D5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.17964 14.4317C8.46083 14.1505 8.9167 14.1505 9.19788 14.4317C9.38761 14.6215 9.92511 14.9127 10.7633 15.1097C11.2779 15.2306 11.8678 15.3066 12.4888 15.3066C13.1097 15.3066 13.6996 15.2306 14.2142 15.1097C15.0524 14.9127 15.5899 14.6215 15.7796 14.4317C16.0608 14.1505 16.5167 14.1505 16.7979 14.4317C17.0791 14.7129 17.0791 15.1687 16.7979 15.4499C16.3258 15.922 15.4753 16.2926 14.5436 16.5115C13.9246 16.657 13.2242 16.7466 12.4888 16.7466C11.7533 16.7466 11.0529 16.657 10.4339 16.5115C9.50224 16.2926 8.65172 15.922 8.17962 15.4499C7.89845 15.1687 7.89846 14.7129 8.17964 14.4317Z"
        fill="#EBEFFF"
      />
      <path
        d="M8.28906 11.5668C8.28906 11.8851 8.41549 12.1903 8.64053 12.4153C8.86558 12.6404 9.1708 12.7668 9.48906 12.7668C9.80732 12.7668 10.1125 12.6404 10.3376 12.4153C10.5626 12.1903 10.6891 11.8851 10.6891 11.5668C10.6891 11.2486 10.5626 10.9433 10.3376 10.7183C10.1125 10.4932 9.80732 10.3668 9.48906 10.3668C9.1708 10.3668 8.86558 10.4932 8.64053 10.7183C8.41549 10.9433 8.28906 11.2486 8.28906 11.5668Z"
        fill="white"
      />
      <path
        d="M14.2891 11.5668C14.2891 11.8851 14.4155 12.1903 14.6405 12.4153C14.8656 12.6404 15.1708 12.7668 15.4891 12.7668C15.8073 12.7668 16.1125 12.6404 16.3376 12.4153C16.5626 12.1903 16.6891 11.8851 16.6891 11.5668C16.6891 11.2486 16.5626 10.9433 16.3376 10.7183C16.1125 10.4932 15.8073 10.3668 15.4891 10.3668C15.1708 10.3668 14.8656 10.4932 14.6405 10.7183C14.4155 10.9433 14.2891 11.2486 14.2891 11.5668Z"
        fill="white"
      />
    </svg>
  );
};

export default ConnectDiscord;
